import React from 'react';
import classNames from 'classnames';
import {PostWrapper, PostModal} from './post_utils.jsx';
import Shave from '../shave/index.jsx';
import LazyImg from '../lazy_img/index.jsx';

export const LinkPost = ({
    link, id, image, linkTitle, linkSummary, message, linkPostHover, hideNewsOverlay, externalWindowLinkAriaText
}) => {
    const isShowMessage = message || hideNewsOverlay;
    const titleLinkClass = classNames('link-message__title', { 'link-message__title--black': hideNewsOverlay });
    const postWrapperClass = classNames({
        'link-and-message': isShowMessage,
        'link-only': !isShowMessage
    });

    let linkAriaText = linkTitle;
    linkAriaText += isShowMessage && message
        ? (linkAriaText && ['.', '?', '!', ';'].includes(linkAriaText[linkAriaText.length - 1]) ? '' : '.')
        + (message ? ' ' + message : '')
        : '';
    linkAriaText += linkSummary
        ? (linkAriaText && ['.', '?', '!', ';'].includes(linkAriaText[linkAriaText.length - 1]) ? '' : '.')
        + (linkSummary ? ' ' + linkSummary : '')
        : '';

    return (
        <PostWrapper
            className={postWrapperClass}
            href={link}
            overlaySymbol={message ? "eye" : "external-link"}
            overlayText={linkPostHover}
            target="_blank"
            id={id}
            title={linkTitle}
            ariaText={linkAriaText}
            externalWindowLinkAriaText={externalWindowLinkAriaText}
        >
            <div className="link">
                <div className="image">
                    <LazyImg src={image} alt={linkTitle || ""} />
                </div>
                {!hideNewsOverlay &&
                <div className="summary">
                    {message ?
                        <h6 className="summary__title">{linkTitle}</h6>
                        :
                        <div>
                            <h3 className="summary__title">{linkTitle}</h3>
                            <p className="summary__message">{linkSummary}</p>
                        </div>
                    }
                    <p className="summary__url url">{link}</p>
                </div>
                }
            </div>
            {isShowMessage &&
            <Shave className="link-message message">
                <h3 className={titleLinkClass}>{linkTitle}</h3>
                {message && <p className="link-message__message">{message}</p>}
                <p className="link-message__summary">{linkSummary}</p>
            </Shave>
            }
        </PostWrapper>
    );
};

export const ImagePost = ({ id, image, message, linkTitle, imagePostHover, externalWindowLinkAriaText }) => {
    const postId = message ? `hs-post-image-and-message-${id}` : `hs-post-image-only-${id}`;

    let linkAriaText = linkTitle;
    linkAriaText += message
        ? (linkAriaText && ['.', '?', '!', ';'].includes(linkAriaText[linkAriaText.length - 1]) ? '' : '.')
        + (message ? ' ' + message : '')
        : '';

    return (
        <div>
            <PostWrapper
                className={message ? "image-and-message" : "image-only"}
                href={`#${postId}`}
                overlayText={imagePostHover}
                id={id}
                ariaText={linkAriaText}
                externalWindowLinkAriaText={externalWindowLinkAriaText}
            >
                <div className="image">
                    <LazyImg src={image} alt={linkTitle || ""} />
                </div>
                {message &&
                    <Shave className="message">
                        <h3>{linkTitle}</h3>
                        <p className="image-and-message__message">{message}</p>
                    </Shave>
                }
            </PostWrapper>
            <PostModal id={postId}>
                <LazyImg src={image} alt={linkTitle || ""} />
                <br />
                {message &&
                    <p className="image-and-message-modal__message">{message}</p>
                }
            </PostModal>
        </div>
    );
};

export const TextPost = ({ id, message, defaultPostHover, externalWindowLinkAriaText}) => {
    const postId = `hs-post-text-only-${id}`;
    return (
        <div>
            <PostWrapper
                className="text-only"
                href={`#${postId}`}
                overlaySymbol="external-link"
                overlayText={defaultPostHover}
                id={id}
                ariaText={message}
                externalWindowLinkAriaText={externalWindowLinkAriaText}
            >
                <Shave className="message">
                    <p className="text-only__message">{message}</p>
                </Shave>
            </PostWrapper>3
            <PostModal id={postId}>
                <p>{message}</p>
            </PostModal>
        </div>
    );
};



// WEBPACK FOOTER //
// ./components/post_list/posts.jsx